@if (loadingService.isLoadingActive()) {
  <app-loading></app-loading>
}
<router-outlet></router-outlet>
